// Copyright (c) 2016 Deere & Company

import SpaClaim from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance';

export const getUpdatedSpaClaim = (currentClaim, selectedAction) =>
    SpaClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/spa/services/update-spa-claim.js